"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function gusd(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M14.5335 3.75C11.631 3.75 9.16575 5.982 8.856 8.85525C5.98125 9.16575 3.75 11.631 3.75 14.5328C3.75079 16.0487 4.3533 17.5023 5.42516 18.5743C6.49701 19.6463 7.95056 20.249 9.4665 20.25C12.369 20.25 14.844 18.018 15.144 15.1448C18.018 14.8343 20.25 12.369 20.25 9.46725C20.2492 7.95131 19.6467 6.49768 18.5748 5.42569C17.503 4.35369 16.0494 3.75099 14.5335 3.75ZM18.9105 10.107C18.7678 11.0445 18.3291 11.9119 17.6585 12.5825C16.9879 13.2531 16.1205 13.6918 15.183 13.8345V10.107H18.9105ZM5.0895 13.893C5.23031 12.9537 5.66815 12.0841 6.33889 11.4116C7.00963 10.7391 7.87805 10.299 8.817 10.1558V13.8832H5.0895V13.893ZM13.8442 15.183C13.6894 16.2331 13.1619 17.1925 12.3581 17.8858C11.5544 18.5791 10.528 18.9602 9.4665 18.9592C8.40521 18.9602 7.37902 18.5792 6.5754 17.886C5.77177 17.1929 5.24435 16.2337 5.0895 15.1838H13.8442V15.183ZM13.893 10.107V13.8832H10.107V10.107H13.893ZM18.9105 8.817H10.1558C10.3106 7.76687 10.8381 6.80751 11.6419 6.11418C12.4456 5.42085 13.472 5.03984 14.5335 5.04075C15.5948 5.03984 16.621 5.42077 17.4246 6.11396C18.2282 6.80715 18.7556 7.76632 18.9105 8.81625V8.817Z", fill: color }));
}
exports["default"] = gusd;
//# sourceMappingURL=gusd.js.map